import { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import * as D from "assets/iconsSVG/rowTopDownIcon";
import * as MaterialUI from "@material-ui/core";
import { useCompartilharOportunidade } from "services/api/AppWeb_Oportunidade/put-compartilhar";
import SelectAutoComplete from "components/selectAutoCompleteG";
import { useListarUsuariosCorretores } from "services/api/Identity_Usuario/listar-usuarios-corretores";
import * as S from "./styles";

interface Data {
  onClose: () => void;
  dataDetalheOportunidade: any;
  refetchDetalheOportunidade: () => void;
  refetchHistorico: () => void;
}

export const ModalCompartilhar = (data: Data) => {
  const [value, setValue] = useState<any>({});
  const { mutate: mutateCompartilhar, isLoading: isLoadingCompartilhar } =
    useCompartilharOportunidade();

  const { data: dataCorretores, refetch: refetchCorretores } =
    useListarUsuariosCorretores({
      queryKey: "listar-corretores-equipe-entrada",
    });

  useEffect(() => {
    if (dataCorretores?.data === undefined) {
      refetchCorretores();
    }
  }, []);

  const handleSubmit = () => {
    mutateCompartilhar(
      {
        idOportunidade: data.dataDetalheOportunidade.idOportunidade,
        IdCorretorDestino365: value.value,
        NomeCorretorDestino365: value.label,
      },
      {
        onSuccess: () => {
          data.refetchDetalheOportunidade();
          data.refetchHistorico();
          data.onClose();
        },
      }
    );
  };

  return (
    <S.Content>
      <S.Header>
        <S.Row style={{ justifyContent: "space-between" }}>
          <D.RowTopDownIcon />
          <S.CloseButton onClick={data.onClose}>
            <IoCloseOutline size={32} />
          </S.CloseButton>
        </S.Row>
        <S.SpaceY space={16} />
        <S.TextTitle>Compartilhar Proposta</S.TextTitle>
      </S.Header>
      <S.SpaceY space={16} />
      <S.Body>
        <S.InputContainer>
          <SelectAutoComplete
            label="Corretor de destino"
            value={value}
            onChange={(e: any) => {
              setValue(e);
            }}
            data={
              dataCorretores?.data.map((item: any) => ({
                value: item?.idCorretor,
                label: item?.apelido,
              })) || []
            }
          />
        </S.InputContainer>
        <S.SpaceY space={32} />
        <S.Row style={{ gap: 16 }}>
          <S.Button
            onClick={() => {
              data.onClose();
            }}
            color="#ffffff"
            border="1px solid #A3A3A6"
          >
            <S.TextButton color="#424248">Cancelar</S.TextButton>
          </S.Button>
          <S.Button
            onClick={() => {
              handleSubmit();
            }}
            disabled={isLoadingCompartilhar || !value}
          >
            {isLoadingCompartilhar ? (
              <MaterialUI.CircularProgress
                size={22}
                style={{ color: "#ffffff" }}
              />
            ) : (
              <S.TextButton color="#FFFFFF">Compartilhar</S.TextButton>
            )}
          </S.Button>
        </S.Row>
      </S.Body>
    </S.Content>
  );
};
